import React, { Component } from "react";

import { Route, Switch, Redirect, useParams } from "react-router-dom";

import { connect } from "react-redux";

import { changeLoginValue } from "../redux/actions/index";

import PropTypes from "prop-types";

import NotFound from "../components/NotFound";

import { checkValidToken } from "../components/utils/RequestsHelper";

import PontosInteresse from "../components/backoffice/pontos_interesse/PontosInteresse";
import PontoInteresse from "../components/backoffice/pontos_interesse/ponto_interesse_get/PontoInteresse";
import CreatePontoInteresse from "../components/backoffice/pontos_interesse/ponto_interesse_form/CreatePontoInteresse";
import EditPontoInteresse from "../components/backoffice/pontos_interesse/ponto_interesse_form/EditPontoInteresse";

import AquiPertoList from "../components/backoffice/aqui_perto/AquiPertoList";
import AquiPerto from "../components/backoffice/aqui_perto/aqui_perto_get/AquiPerto";
import CreateAquiPerto from "../components/backoffice/aqui_perto/aqui_perto_form/CreateAquiPerto";
import EditAquiPerto from "../components/backoffice/aqui_perto/aqui_perto_form/EditAquiPerto";

import RestauranteList from "../components/backoffice/restaurantes/Restaurantes";
import CreateRestaurante from "../components/backoffice/restaurantes/restaurantes_form/CreateRestaurante";
import Restaurante from "../components/backoffice/restaurantes/restaurante_get/Restaurante";
import EditRestaurante from "../components/backoffice/restaurantes/restaurantes_form/EditRestaurante";

import AlojamentoList from "../components/backoffice/alojamentos/Alojamentos";
import CreateAlojamento from "../components/backoffice/alojamentos/alojamentos_form/CreateAlojamento";
import Alojamento from "../components/backoffice/alojamentos/alojamento_get/Alojamento";
import EditAlojamento from "../components/backoffice/alojamentos/alojamentos_form/EditAlojamento";

import LojaList from "../components/backoffice/lojas/Lojas";
import CreateLoja from "../components/backoffice/lojas/lojas_form/CreateLoja";
import Loja from "../components/backoffice/lojas/loja_get/Loja";
import EditLoja from "../components/backoffice/lojas/lojas_form/EditLoja";

import NoticiaList from "../components/backoffice/noticias/Noticias";
import CreateNoticia from "../components/backoffice/noticias/noticias_form/CreateNoticia";
import Noticia from "../components/backoffice/noticias/noticias_get/Noticia";
import EditNoticia from "../components/backoffice/noticias/noticias_form/EditNoticia";

import EventoList from "../components/backoffice/eventos/Eventos";
import CreateEvento from "../components/backoffice/eventos/eventos_form/CreateEvento";
import Evento from "../components/backoffice/eventos/eventos_get/Evento";
import EditEvento from "../components/backoffice/eventos/eventos_form/EditEvento";
import Inscricao from "../components/backoffice/eventos/eventos_get/Inscricao";

import Avisos from "../components/backoffice/avisos/Avisos";
import CreateAviso from "../components/backoffice/avisos/avisos_form/CreateAviso";
import Aviso from "../components/backoffice/avisos/avisos_get/Aviso";
import EditAviso from "../components/backoffice/avisos/avisos_form/EditAviso";

import EssenciaList from "../components/backoffice/essencia/Essencias";
import CreateEssencia from "../components/backoffice/essencia/essencia_form/CreateEssencia";
import Essencia from "../components/backoffice/essencia/essencia_get/Essencia";
import EditEssencia from "../components/backoffice/essencia/essencia_form/EditEssencia";

import Contactos from "../components/backoffice/contactos/Contactos";
import CreateContacto from "../components/backoffice/contactos/contactos_form/CreateContacto";
import Contacto from "../components/backoffice/contactos/contacto_get/Contacto";
import EditContacto from "../components/backoffice/contactos/contactos_form/EditContacto";

import Pessoas from "../components/backoffice/pessoas/Pessoas";
import CreatePessoa from "../components/backoffice/pessoas/pessoas_form/CreatePessoa";
import Pessoa from '../components/backoffice/pessoas/Pessoa';
import EditPessoa from "../components/backoffice/pessoas/pessoas_form/EditPessoa";

class ProtectedRoutes extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentWillMount() {}

  async componentDidMount() {
    let token = await checkValidToken();

    if (token.response !== undefined) {
      if (token.response.status === 401) {
        //por o isLogged a false
        localStorage.removeItem("isLoggedIn");

        //apagar o que está no token
        localStorage.removeItem("token");

        //alterar o estado no redux
        this.props.ChangeUserState(false);
      }
    }

    console.log(this.context.router);
  }

  render() {
    if (localStorage.getItem("isLoggedIn") === "true") {
      return (
        <Switch>
          <Route path="/backoffice/pontos_interesse/adicionar" component={CreatePontoInteresse}/>
          <Route path="/backoffice/pontos_interesse/editar/:identifier" component={EditPontoInteresse}/>
          <Route
            path="/backoffice/pontos_interesse/:identifier"
            component={PontoInteresse}
          />
          <Route
            path="/backoffice/pontos_interesse"
            component={PontosInteresse}
          />



          <Route
            path="/backoffice/aqui_perto/adicionar"
            component={CreateAquiPerto}
          />
          <Route
            path="/backoffice/aqui_perto/editar/:identifier"
            component={EditAquiPerto}
          />
          <Route
            path="/backoffice/aqui_perto/:identifier"
            component={AquiPerto}
          />
          <Route path="/backoffice/aqui_perto" component={AquiPertoList} />




          <Route
            path="/backoffice/restaurantes/adicionar"
            component={CreateRestaurante}
          />
          <Route
            path="/backoffice/restaurantes/editar/:identifier"
            component={EditRestaurante}
          />
          <Route
            path="/backoffice/restaurantes/:identifier"
            component={Restaurante}
          />
          <Route path="/backoffice/restaurantes" component={RestauranteList} />




          <Route
            path="/backoffice/alojamentos/adicionar"
            component={CreateAlojamento}
          />
          <Route
            path="/backoffice/alojamentos/editar/:identifier"
            component={EditAlojamento}
          />
          <Route
            path="/backoffice/alojamentos/:identifier"
            component={Alojamento}
          />
          <Route path="/backoffice/alojamentos" component={AlojamentoList} />





          <Route path="/backoffice/lojas/adicionar" component={CreateLoja} />
          <Route
            path="/backoffice/lojas/editar/:identifier"
            component={EditLoja}
          />
          <Route path="/backoffice/lojas/:identifier" component={Loja} />
          <Route path="/backoffice/lojas" component={LojaList} />





          <Route
            path="/backoffice/noticias/adicionar"
            component={CreateNoticia}
          />
          <Route
            path="/backoffice/noticias/editar/:identifier"
            component={EditNoticia}
          />
          <Route path="/backoffice/noticias/:identifier" component={Noticia} />
          <Route path="/backoffice/noticias" component={NoticiaList} />





          <Route
            path="/backoffice/eventos/adicionar"
            component={CreateEvento}
          />
          <Route
            path="/backoffice/eventos/editar/:identifier"
            component={EditEvento}
          />
          <Route
            path="/backoffice/eventos/:identifier/:inscricao"
            component={Inscricao}
          />
          <Route path="/backoffice/eventos/:identifier" component={Evento} />
          <Route path="/backoffice/eventos" component={EventoList} />





          <Route path="/backoffice/avisos/adicionar" component={CreateAviso} />
          <Route path="/backoffice/avisos/editar/:identifier" component={EditAviso} />
          <Route path="/backoffice/avisos/:identifier" component={Aviso} />
          <Route path="/backoffice/avisos" component={Avisos} />




          <Route path="/backoffice/essencias/adicionar" component={CreateEssencia} />
          <Route path="/backoffice/essencias/editar/:identifier" component={EditEssencia} />
          <Route path="/backoffice/essencias/:identifier" component={Essencia} />
          <Route path="/backoffice/essencias" component={EssenciaList} />




          <Route path="/backoffice/contactos/adicionar" component={CreateContacto} />
          <Route path="/backoffice/contactos/editar/:identifier" component={EditContacto} />
          <Route path="/backoffice/contactos/:identifier" component={Contacto} />
          <Route path="/backoffice/contactos" component={Contactos} />

          


          <Route path="/backoffice/pessoas/adicionar" component={CreatePessoa} />
          <Route path="/backoffice/pessoas/editar/:_id" component={EditPessoa} />
          <Route path="/backoffice/pessoas/:_id" component={Pessoa} />
          <Route path="/backoffice/pessoas" component={Pessoas} />


          <Route component={NotFound} />
        </Switch>
      );
    } else {
      if (
        this.context.router.route.location.pathname.startsWith("/backoffice/")
      ) {
        return <Redirect to="/login" />;
      } else {
        return <Redirect to="/not_found" />;
      }
    }
  }
}

const mapStateToProps = (store) => ({
  isLoggedIn: store.updateLoginState.isLogged,
});

const mapDispatchToProps = (dispatch) => {
  return {
    ChangeUserState: (isLogged) => dispatch(changeLoginValue(isLogged)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoutes);
